// Redux store configuration
import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/user/userSlice';
import chatReducer from '../features/chat/chatSlice';
import subscriptionPlansReducer from '../features/subscriptionPlansSlice';
import internalChatReducer from '../features/internalChat/internalChatSlice';
import brandDetailsReducer from '../features/brandDetailsSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    chat: chatReducer,
    subscriptionPlans: subscriptionPlansReducer,
    internalChat: internalChatReducer,
    brandDetails: brandDetailsReducer,
  },
});
